import React from "react"
import ContestPlatform from "./ContestPlatform";
class App extends React.Component
{
    render()
    {
        const style={
            display:"flex",
            flexDirection:"row",
            flexWrap:"Wrap",
            flexGrow:"1",
            justifyContent:"center"
        }
        return(
            <div>

            <div style={style}>
                <ContestPlatform function_name="codeforces" providerName="CodeForces"/>
                <ContestPlatform function_name="hackerrank" providerName="HackerRank" />
                <ContestPlatform function_name="atcoder" providerName="AtCoder"/>
                <ContestPlatform function_name="codechef" providerName="CodeChef"/>
            </div>
            </div>
        )
    }
}

export default App